import * as _ from 'underscore';
import { Input } from './input';
import { IFileInputOptions } from '../../../interfaces/options';
import { IKeyValue } from '../../../interfaces';
import { Templates, Localization } from '../../../compile';
import { Util } from '../..';
import * as Globalize from '@mapp/globalize';

export class FileInput extends Input<any> {
	public fileElement: KnockoutObservable<HTMLInputElement>;
	private clickFile: () => void;
	public fileName: KnockoutObservable<string>;
	private fileChanged: (event: any) => void;
	private _post: (formData: FormData) => Promise<any>;
	public fileSizeLimit: number;
	public fileSize: number;
	constructor(id: string, label: string, options?: IFileInputOptions) {
		let fileName = ko.observable<string>();
		options = $.extend(
			true,
			{},
			<IFileInputOptions>{
				widget: {
					widget: Templates.widgets_fileInput
				}
			},
			options || {}
		);
		super(id, label, fileName, options);
		this._post = options.post;
		this.fileElement = ko.observable<HTMLInputElement>();
		this.clickFile = () => {
			this.fileElement().click();
		};
		this.fileName = fileName;
		this.fileSize = 0;
		this.fileSizeLimit = options.fileSizeLimit;
		if (this.fileSizeLimit !== undefined && this.fileSizeLimit > 0) {
			ko.validation.addRule(this.fileName, {
				rule: 'fileSize',
				params: this,
				message: Util.toByteString(this.fileSizeLimit)
			});
		}

		this.fileChanged = () => {
			if (this.fileElement().files.length > 0) {
				let _file: File = this.fileElement().files[0];
				this.fileSize = _file.size;
				this.fileName(_file.name);
			} else {
				this.fileSize = 0;
				this.fileName(null);
			}
		};
	}
	//overwrite
	public serialize(serializeObject: IKeyValue<any>): IKeyValue<any> {
		serializeObject[this.id] = this.fileName();
		return serializeObject;
	}
	public post<T>(url?: string, ajax?: (settings: JQueryAjaxSettings) => Promise<T>): Promise<T> {
		if (_.isUndefined(this._post) && (_.isUndefined(url) || _.isUndefined(ajax))) {
			throw new Error('File upload: missing post settings');
		}
		let post: (formData: FormData) => Promise<any> = this._post;
		//TODO delete old post behaviour and post params
		if (_.isUndefined(post)) {
			post = (formData: FormData): Promise<any> => {
				return ajax({
					url: url,
					type: 'POST',
					data: formData,
					cache: false,
					contentType: false,
					processData: false
				});
			};
		}

		let formData = this.getFormData();

		if (!formData) {

			let deferred = jQuery.Deferred();
			deferred.resolve();
			return deferred.promise();
		}
		else
			return post(formData);
	}

	public getFormData(): FormData {

		if (!this.fileElement().files || this.fileElement().files.length == 0) 
			return undefined;

		var formData = new FormData();
		formData.append('file', this.fileElement().files[0]);
		return formData
	}
	

	public reset() {
		$(this.fileElement()).val('');
		this.fileName(null);
	}
}
